// extracted by mini-css-extract-plugin
export default {"zoomMenu":"src-signer-app-parts-toolbar-zoom-controls-toolbar-zoom-controls-module__zoomMenu--GGwet"};